export const FETCH_CONTACT_US_FORM_REQUEST = 'FETCH_CONTACT_US_FORM_REQUEST';
export const FETCH_CONTACT_US_FORM_RECEIVE = 'FETCH_CONTACT_US_FORM_RECEIVE';
export const FETCH_CONTACT_US_REQUEST = 'FETCH_CONTACT_US_REQUEST';
export const FETCH_CONTACT_US_RECEIVE = 'FETCH_CONTACT_US_RECEIVE';